import React, {Component, createRef} from 'react';

export default class CodeInput extends Component {
  constructor(props) {
    super(props);
    let {size} = props;
    let values = Array(size).fill('');

    this.state = {values};
    this.valueRefs = values.map(() => createRef());
    this.containerRef = createRef();

    this.onPaste = this.onPaste.bind(this);
  }

  componentDidMount() {
    this.valueRefs[0].current.focus();
    this.containerRef.current.addEventListener('paste', this.onPaste, false);
  }

  componentWillUnmount() {
    this.containerRef.current.removeEventListener('paste', this.onPaste, false);
  }

  submit() {
    let {onSubmit} = this.props;
    let {values} = this.state;
    let value = values.join('');
    onSubmit(value);
  }

  change(e, index) {
    let {values} = this.state;
    let {value} = e.target;
    values[index] = value;
    this.setValues(values, index);
  }

  setValues(values, index) {
    this.setState({values}, () => {
      if (index !== values.length -1) {
        index = index + 1;
        this.valueRefs[index].current.focus();
      } else {
        this.submit();
      }
    });
  }

  onPaste(e) {
    e.preventDefault();
    let pasted_str = e.clipboardData.getData('Text');
    let {values} = this.state;

    let size = Math.min(values.length, pasted_str.length);
    for (let i = 0; i < size; i++) {
      values[i] = pasted_str.charAt(i);
    }

    this.setValues(values, size - 1);
  }


  render() {
    let {values} = this.state;
    return (
      <div ref={this.containerRef} className="code_entry_holder">
        {values.map((value, index) => {
          return <input type="text" key={index} value={value} size={1} onChange={e => this.change(e, index)} ref={this.valueRefs[index]} />
        })}
        <button className="btn btn-success" onClick={e => this.submit()}>Submit</button>
      </div>
    )
  }
}
